import * as R from 'ramda';
import Address from './address';

export default function Referent(data){
    let referent = data || {};
    this.id = referent.id;
    this.email = R.isNil(referent.email) ? "" : referent.email;
    this.gender = referent.gender === '0' ? undefined: referent.gender;
    this.firstName = R.isNil(referent.firstName) ? "" : referent.firstName;
    this.lastName = R.isNil(referent.lastName) ? "" : referent.lastName;
    this.birthDate = referent.birthDate === '0001-01-01T00:00:00Z' || R.isNil(referent.birthDate) ? undefined : new Date(referent.birthDate);
    this.representativeType = referent.representativeType === '0' ? undefined: referent.representativeType;
    this.isMainRepresentative = referent.isMainRepresentative;
    this.userId = referent.userId;
    this.address = referent.address !== undefined ? referent.address : undefined;
    this.tmpRef = referent.tmpRef !== undefined ? referent.tmpRef: undefined;
    this.phoneNumber = R.isNil(referent.phoneNumber) ? "" : referent.phoneNumber;
    this.addresses = referent.addresses !== undefined ? referent.addresses.map(a => new Address(a)) : [];
}